import _defineProperty from "@babel/runtime/helpers/defineProperty";
//
// Copyright IBM Corp. 2020, 2020
//
// This source code is licensed under the Apache-2.0 license found in the
// LICENSE file in the root directory of this source tree.
//
var attribute = 'data-ui-id';
export function idAttributeSelector(identifier) {
  var attr = "[".concat(attribute, "=\"").concat(identifier, "\"]");
  return attr;
}
export function fuzzyAttributeSelector(identifier) {
  var attr = "[".concat(attribute, "*=\"").concat(identifier, "\"]");
  return attr;
}
export function idAttribute(identifier) {
  var attr = _defineProperty({}, attribute, identifier);

  return attr;
}